import { definePlugin } from '/@/app'
import { useScreenSizeStore } from '/@/store/modules/screenSize'

/**
 * Screen Size Store Plugin
 * Automatically initializes the screen size store when the app starts
 * and handles cleanup on app unmount
 */
export default definePlugin(async ({ app }) => {
  if (typeof window !== 'undefined') {
    const screenSizeStore = useScreenSizeStore()

    // Initialize the store
    screenSizeStore.init()

    // Add cleanup on app unmount
    const originalUnmount = app.unmount
    if (originalUnmount) {
      app.unmount = function unmount() {
        screenSizeStore.destroy()
        return originalUnmount.call(this)
      }
    }
  }
})
